import { FC, MouseEvent } from 'react';
import { DropdownItem } from 'react-bootstrap';

import type { IResultPanelProps } from '../Typeahead.models';

export const StringResultPanel: FC<IResultPanelProps<string>> = ({
  availableValues,
  selectedIndex,
  onSelectionMouseDown,
}) => {
  return (
    <>
      {availableValues.slice(0, 15).map((selectionItem, index) => (
        <DropdownItem
          active={index === selectedIndex}
          data-value={selectionItem}
          key={index}
          onMouseDown={handleMouseDown(onSelectionMouseDown, selectionItem)}
        >
          <span ref={selectedIndex === index ? handleSelectedValue : undefined}>{selectionItem}</span>
        </DropdownItem>
      ))}
    </>
  );
};

function handleMouseDown(
  callback: (selectionItem: string) => void,
  selectionItem: string,
): (e: MouseEvent<HTMLElement>) => void {
  return () => {
    callback(selectionItem);
  };
}

function handleSelectedValue(el: HTMLLIElement | null) {
  if (el !== null) {
    el.scrollIntoViewIfNeeded();
  }
}
